import { useEffect, useState } from "react";
import styles from "./AdminPanelCountries.module.scss";
import { CountriesService } from "../../../services/countries.service";
import { CountriesDataType } from "../../../interface/site.interface";
import { Base_Url } from "../../../constants/base_url";

const AdminPanelCountries = ({
  onCountrySelect,
}: {
  onCountrySelect: (id: number, name: string) => void;
}) => {
  const [countries, setCountries] = useState<CountriesDataType[]>([]);
  const [selectedCountryId, setSelectedCountryId] = useState<number | null>(
    null
  );
  const [hasFetched, setHasFetched] = useState(false);

  useEffect(() => {
    if (!hasFetched) {
      CountriesService.getAllCountries().then((response) => {
        const allCountries = response?.data?.original || [];
        setCountries(allCountries);
        setHasFetched(true);

        if (allCountries.length > 0 && selectedCountryId === null) {
          const firstCountry = allCountries[0];
          setSelectedCountryId(firstCountry.id);
          onCountrySelect(firstCountry.id, firstCountry.title);
        }
      });
    }
  }, [hasFetched]);

  const handleCountryClick = (countryId: number, countryName: string) => {
    setSelectedCountryId(countryId);
    onCountrySelect(countryId, countryName);
  };

  return (
    <div className={styles.name_buttons}>
      <div className={styles.countries_name}>
        {countries?.map((country) => (
          <button
            key={country.id}
            className={`${styles.country_name} ${
              selectedCountryId === country.id ? styles.active_btn : ""
            }`}
            onClick={() => handleCountryClick(country.id, country.title)}
          >
            <img src={`${Base_Url}${country.image}`} alt={country.title} />
            <p>{country.title}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminPanelCountries;
